import { isEqual } from 'lodash-es';
import { useCallback, useState } from 'react';
import { Podcast } from 'api';
import { useMyDefaultPodcast } from 'state/podcast';
import { useEddyPrefsOverride } from 'state/userPref';
import { EddyPref } from 'state/userPref/types';
import useUpdateEddyPrefs from 'state/userPref/useUpdateEddyPrefs';

export interface UseUpdateAIOptions {
  isLoading: boolean;
  defaultPodcast: Podcast | undefined;
  prefs: EddyPref | undefined;
  onChange: (prefs: EddyPref) => void;
  onSubmit: () => Promise<void>;
}

export default function useUpdateAIOptions(): UseUpdateAIOptions {
  const { data: prefs, isFetched: isEddyPrefsFetched } = useEddyPrefsOverride();
  const { data: defaultPodcast, isFetched: isDefaultPodcastFetched } =
    useMyDefaultPodcast();

  const [draftPrefs, setDraftPrefs] = useState(prefs);

  const { mutateAsync: updateEddyPrefs } = useUpdateEddyPrefs();

  const handleOnSubmit = useCallback(async (): Promise<void> => {
    if (!draftPrefs) {
      return;
    }

    if (!isEqual(draftPrefs, prefs)) {
      await updateEddyPrefs(draftPrefs);
    }
  }, [draftPrefs, prefs, updateEddyPrefs]);

  if (!draftPrefs && !isEqual(draftPrefs, prefs)) {
    setDraftPrefs(prefs);
  }

  return {
    defaultPodcast,
    isLoading: !isEddyPrefsFetched || !isDefaultPodcastFetched,
    onChange: setDraftPrefs,
    onSubmit: handleOnSubmit,
    prefs: draftPrefs,
  };
}
